module.exports = __webpack_public_path__ + "img/ufc.712731cb.png";